import { allImages } from "../../services/images";
import { Heading } from "../../components/Reusable/resuable";
import { useAppSelector } from "../../Redux/hook";
import { useRef, useEffect } from "react";
import { Helmet } from "react-helmet-async";
import './announcements.scss';
export default function Announcements() {
    const lightMode = useAppSelector((state) => state.mode.lightMode);
    const sectionref = useRef<HTMLDivElement | null>(null);
    const announcements = [
        {
            title: "Website Launch",
            message: "We are glad to announce that we are launching our website with all the advancements and new designs."
        },
        {
            title: "Our Leadership",
            message: "At PBL, our Board of Directors brings extensive experience, strategic vision, and leadership to drive innovation and growth. Their expertise ensures that we continue to uphold our commitment to excellence, sustainability, and stakeholder value.So we are glad to announce that Ms. takes the role of CEO"
        }
    ];
    useEffect(() => {
        const timer = setTimeout(() => {
            sectionref.current?.scrollIntoView({ behavior: "smooth", block: "center" });
        }, 2000);
        return () => clearTimeout(timer);
    }, [])
    return <div className="announcements">
        <Helmet>
            <title>Announcments - PBL Transport</title>
        </Helmet>
        <div className="banner">
            <div className="guard"></div>
            <div className="announce">
                <div className="content">
                    <div>Announcements</div>
                </div>
                <img src={allImages.announcement} alt="blog" />
            </div>
        </div>
        <div ref={sectionref}></div>
        <div className="messages">
            <Heading heading="Announcements" lightMode={lightMode} />
            {
                announcements.map((item, index) => (
                    <div className="cards" key={index}>
                        <img src={allImages.announcementgif} alt="logo" />
                        <div className="content">
                            <div className="head">{item.title}</div>
                            <div className="message">{item.message}</div>
                        </div>
                    </div>))
            }
        </div>
    </div>
}